import { render } from "./train.vue?vue&type=template&id=998082ba&scoped=true"
import script from "./train.vue?vue&type=script&lang=js"
export * from "./train.vue?vue&type=script&lang=js"

import "./train.vue?vue&type=style&index=0&id=998082ba&rel=stylesheet%2Fscss&lang=scss"
import "./train.vue?vue&type=style&index=1&id=998082ba&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998082ba"]])

export default __exports__